import React from 'react'
import PropTypes from 'prop-types'
import { SidebarHeader, TextLogo } from 'labguard-cdk'

const NavBrand = ({ color }) => (
  <SidebarHeader>
    <TextLogo color={color} />
  </SidebarHeader>
)

NavBrand.defaultProps = {
  color: 'white',
}

NavBrand.propTypes = {
  color: PropTypes.string,
}

export default NavBrand
